import { useEffect, useState } from "react";
import { EnvironmentsAPI } from "../../../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../../../tools/EnvironmentStorage";

import TagsList from "../../../Tags/TagsList";
import { Loading } from "../../../../../components/Loading";
import styles from "../../../../../../styles/catalog-tags.module.scss";

export const ProductTagsStep = ({ item, onChange }) => {
    const [defaultTags, setDefaultTags] = useState([]);
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState([]);
    

    const loadTags = async () => {
        setLoading(true);
        const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();

        const catalogTags = await EnvironmentsAPI.getConfigurationsByAlias(
            holdingId,
            "catalog_tags"
        );

        if (catalogTags?.length > 0) {
            const activeTags = catalogTags.filter((tag) => tag.active === true);

            if (activeTags?.length > 0) {
                return activeTags;
            }
        }
        return [];
    };

    const changeTags = (tagType, checked) => {
        const newTags = tags.map((tag) => {
            if (tag.type === tagType) tag.checked = !tag.checked;
            return tag;
        });
        setTags(newTags);

        const checkedTags = newTags.filter((tag) => tag.checked === true) || [];

        onChange({
            tags: checkedTags.map((checkedTag) => {
                const { id, name, type, iconUrl } = checkedTag;
                return { id, name, type, iconUrl };
            }),
        });
    };

    const tagIsChecked = (tagType) => {
        const foundTag = (item?.tags || []).find((tag) => tag.type === tagType);
        return foundTag?.type === tagType;
    };

    useEffect(() => {
        loadTags().then((tags) => {
            if (tags?.length > 0) setDefaultTags(tags);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        setTags(
            defaultTags.map((tag) => {
                return { ...tag, checked: tagIsChecked(tag.type) };
            })
        );
    }, [defaultTags]);

    return (
        <>
            {loading && (
                <div className={styles.loading}>
                    <Loading />
                </div>
            )}
            {!loading && (
                <TagsList
                    tags={tags}
                    onSelectTag={(tag) => changeTags(tag.type, tag.checked)}
                />
            )}
        </>
    );
};
